<div class="container" style=" border: 1px solid #0076ce;margin: 10%;">
    <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Attachment Utility User-Guides
    </h2>
    <div class="tableFixHead_add_row dds__table-striped"
        style="margin: 1rem;  overflow-x: auto; margin-bottom: 0;padding-top: 3rem;padding-bottom: 3rem;">
        <table class="dds__table">
            <thead>
                <tr>
                    <th>Choose File:</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td style="width: 85%;">
                        <select name="fileNames" aria-label="" class="dds__form-control" id="fileNames" #fileNames
                            [(ngModel)]="fileName" style="width: 100%;">

                            <option *ngFor="let userGuide of userGuides" [value]="userGuide">{{userGuide}}</option>

                        </select>
                    </td>
                    <td><button role="button" type="button" class="dds__btn dds__btn-primary dds__text-truncate"
                            style="margin-right: 1%;" (click)="downloadFile()">Download</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>